/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-onchange */
/* eslint-disable jsx-a11y/no-redundant-roles */
/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
import React, { useCallback, useRef } from 'react';
import ReactDOM from 'react-dom';
import { LocaleService } from '@jutro/locale';
// eslint-disable-next-line import/no-extraneous-dependencies
import DatePicker from 'react-datepicker';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-datepicker/dist/react-datepicker.css';
import styles from './wsib-date-picker.module.scss';

const WsibDatePicker = ({
    selectedDate,
    rawValue,
    onRawChange,
    onChangeDate,
    maxDate,
    minDate,
    placeholder = 'YYYY-MM-DD',
    dateFormat = 'yyyy-MM-dd',
    isError,
    ...props
}) => {
    // Default bounds when props are not provided
    const DEFAULT_MIN_YEAR = 1900;
    const DEFAULT_MAX_YEAR = 2035;
    const DEFAULT_MIN_DATE = new Date(DEFAULT_MIN_YEAR, 0, 1); // Jan 1, 1900
    const DEFAULT_MAX_DATE = new Date(DEFAULT_MAX_YEAR, 11, 31); // Dec 31, 2035

    // Effective bounds based on provided props or defaults
    const hasValidMin = (minDate instanceof Date) && !Number.isNaN(minDate.getTime());
    const hasValidMax = (maxDate instanceof Date) && !Number.isNaN(maxDate.getTime());
    const effectiveMinDate = hasValidMin ? minDate : DEFAULT_MIN_DATE;
    // const effectiveMaxDate = hasValidMax ? maxDate : DEFAULT_MAX_DATE;

    // NEW: clamp max date to today so future dates are not visible
    const today = new Date();
    const todayWithoutTime = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
    );

    const rawMaxDate = hasValidMax ? maxDate : DEFAULT_MAX_DATE;
    const effectiveMaxDate = rawMaxDate.getTime() > todayWithoutTime.getTime()
        ? todayWithoutTime
        : rawMaxDate;

    // Compute year range for dropdown based on effective bounds
    const startYear = effectiveMinDate.getFullYear();
    const endYear = effectiveMaxDate.getFullYear();

    // Resolve app language for month names (supports fr*/en*, defaults to en)
    const appLang = (LocaleService && LocaleService.currentLanguage) || 'en';
    const monthLocale = appLang && appLang.toLowerCase().startsWith('fr') ? 'fr' : 'en';

    const monthLabel = (year, monthIndex) => {
        const raw = new Date(year, monthIndex).toLocaleString(monthLocale, { month: 'long' }) || '';
        return raw ? `${raw.charAt(0).toUpperCase()}${raw.slice(1)}` : '';
    };

    // Define the custom header component function
    const CustomHeader = ({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
    }) => (
        <div className={styles.customHeaderContainer}>
            {/* Navigation and Dropdowns Container */}
            <div className={styles.headerControls}>
                {/* Previous Month Button */}
                <button
                    onClick={decreaseMonth}
                    role="button"
                    tabIndex={0}
                    aria-label="Move to Previous Month using Left arrow"
                    disabled={prevMonthButtonDisabled}
                    className={styles.navButton}
                >
                    {'<'}
                </button>
                {/* Year Dropdown: start at current year when in bounds */}
                <select
                    value={date.getFullYear()}
                    onChange={({ target: { value } }) => changeYear(parseInt(value, 10))}
                    className={styles.yearSelect}
                >
                    {/* {(() => {
                        const nowYear = new Date().getFullYear();
                        const minY = startYear;
                        const maxY = endYear;

                        if (nowYear >= minY && nowYear <= maxY) {
                            const futureAsc = Array.from(
                                { length: (maxY - nowYear) }, (_, i) => nowYear + 1 + i
                            );
                            const pastDesc = Array.from(
                                { length: (nowYear - minY) }, (_, i) => nowYear - 1 - i
                            );
                            const ordered = [nowYear, ...futureAsc, ...pastDesc];
                            return ordered.map((year) => (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                            ));
                        }

                        return Array.from(
                            { length: (maxY - minY + 1) }, (_, i) => maxY - i
                        ).map((year) => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ));
                    })()}
                </select>

                {/* Month Dropdown (localized month names)
                <select
                    value={date.getMonth()}
                    onChange={({ target: { value } }) => changeMonth(value)}
                    className={styles.monthSelect}
                > */}
                    {/* Dynamically generate options for months */}
                    {Array.from(
                        { length: endYear - startYear + 1 },
                        (_, i) => endYear - i
                    ).map((year) => (
                        <option key={year} value={year}>
                            {year}
                        </option>
                    ))}
                </select>

                {/* Month Dropdown (localized month names) */}
                <select
                    value={date.getMonth()}
                    onChange={({ target: { value } }) => changeMonth(value)}
                    className={styles.monthSelect}
                >
                    {/* Dynamically generate options for months */}
                    {Array.from({ length: 12 }, (_, i) => (
                        <option key={i} value={i}>
                            {monthLabel(date.getFullYear(), i)}
                        </option>
                    ))}
                </select>
                {/* Next Month Button */}
                <button
                    onClick={increaseMonth}
                    role="button"
                    tabIndex={0}
                    aria-label="Move to Next Month using Right arrow"
                    disabled={nextMonthButtonDisabled}
                    className={styles.navButton}
                >
                    {'>'}
                </button>
            </div>
            {/* Removed manual weekday labels to avoid duplicate display */}
        </div>
    );

    const CalendarIcon = () => (
        <div
            tabIndex={0}
            role="button"
            aria-label="Calendar"
            className={styles.focusBox}
            onClick={() => {
                const inputEl = document.getElementById(props.id);
                if (inputEl) {
                    inputEl.focus();
                    inputEl.click();
                }
            }}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const inputEl = document.getElementById(props.id);
                    if (inputEl) {
                        inputEl.focus();
                        inputEl.click();
                    }
                }
            }}
        >
            <img
                src={require('../../../../src/assets/images/datepicker/calendarIcon.svg')}
                alt="Calendar Icon"
                width={18}
                height={18}
                className={styles.datePickerIconStyle}
            />
        </div>
    );

    const closeByTabRef = useRef(false);
    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Tab') {
            closeByTabRef.current = true;
            // allow default tabbing to next element
            return;
        }
        closeByTabRef.current = false;
    }, []);

    const handleCalendarClose = useCallback(() => {
        // If user pressed Tab, DO NOT steal focus
        if (closeByTabRef.current) {
            closeByTabRef.current = false;
            return;
        }

        // Otherwise restore focus (if you truly need it)
        const el = document.getElementById('dateSelectionFromToAcc');
        if (el) {
            requestAnimationFrame(() => el.focus());
        }
    }, []);

    return (
        <div className={styles.datePickerRow}>
            <DatePicker
                // eslint-disable-next-line react/destructuring-assignment
                id={props.id}
                selected={selectedDate}
                value={rawValue}
                onChange={onChangeDate}
                onChangeRaw={onRawChange}
                maxDate={effectiveMaxDate}
                minDate={effectiveMinDate}
                placeholderText={selectedDate ? '' : placeholder}
                className={`${styles.datePickerInput} ${isError ? styles.error : ''}`}
                dateFormat={dateFormat}
                renderCustomHeader={CustomHeader}
                onKeyDown={handleKeyDown}
                onCalendarClose={handleCalendarClose}
                popperContainer={({ children }) => ReactDOM.createPortal(children, document.body)}
                {...props}
            />
            {CalendarIcon()}
        </div>
    );
};

export default WsibDatePicker;
